import { authenticationFailure } from '@/components/AuthenticationHandler/actions'
import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'
import { getCognitoUserPoolId, getTenantAPIHost } from '@/store/selectors'

import {
  FETCH_CONSOLE_CONFIGURATION,
  FETCH_CONTEXT_ORGANIZATION,
  FETCH_CONTEXT_USER,
  FETCH_TENANT_CONFIGURATION,
  LOAD_REDUX_STATE,
  SAVE_REDUX_STATE
} from './actionTypes'

export const fetchTenantConfiguration = (isAdminLogin?: boolean): AppThunk => {
  return (dispatch, getState) => {
    dispatch(
      request(
        '/config/config.json',
        FETCH_TENANT_CONFIGURATION,
        {},
        {
          args: { isAdminLogin },
          cached: getTenantAPIHost(getState()) !== null,
          service: false,
          setAuthorization: false
        }
      )
    )
  }
}

export const fetchConsoleConfiguration = (spaceId: string): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        '/v1/flags',
        FETCH_CONSOLE_CONFIGURATION,
        {
          method: 'POST',
          body: {},
          headers: { 'x-workgrid-space': spaceId }
        },
        { service: false }
      )
    )
}

export const fetchContextUser = (): AppThunk => {
  return (dispatch, getState) => {
    // @ts-expect-error
    dispatch(request('/user', FETCH_CONTEXT_USER)).then(user => {
      if (getCognitoUserPoolId(getState()) !== user?.organizationUserPoolId) {
        dispatch(authenticationFailure())
      }
    })
  }
}

export const fetchContextOrganization = (): AppThunk => {
  return dispatch => dispatch(request('/user/organization', FETCH_CONTEXT_ORGANIZATION))
}

export const loadPersistedReduxState = (): AppThunk => {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(LOAD_REDUX_STATE))))
}

export const persistReduxState = (): AppThunk => {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(SAVE_REDUX_STATE))))
}
